<template>
  <v-alert
      :prominent="$vuetify.breakpoint.smAndUp"
      type="error"
      width="100%"
      class="error"
    >
      <v-btn small icon absolute right @click.stop="$emit('close', $event)"><v-icon>mdi-close</v-icon></v-btn>
      <v-row align="center">
        <v-col class="grow">
          <div class="error-message">
            <h1><slot name="title"></slot></h1>
            <p>
              <slot name="message"></slot>
            </p>
            <div class="more" v-if="moreVisible">
              <slot name="more"></slot>
            </div>
            <v-btn fab small absolute bottom right @click.stop="toggleMore" color="error darken-2"><v-icon>{{moreVisible ? 'mdi-chevron-up' : 'mdi-chevron-down'}}</v-icon></v-btn>
            <!-- <pre v-show="moreVisible">{{error.response.error.stack}}</pre> -->
          </div>
        </v-col>
      </v-row>
    </v-alert>
</template>

<script>

export default {
  name: 'AlertTemplate',
  computed : {},
  data()
  {
    return {
      moreVisible:false,
    }
  },
  methods : {
    toggleMore()
    {
      this.moreVisible = !this.moreVisible;
    },
  }
}
</script>

<style scoped lang="scss">
.error
{
  h1
  {
    font-size:18px;
    font-weight:normal;
  }
  p
  {
    font-size:18px;
    font-weight:normal;
    opacity:.8;
  }
  pre
  {
    font-size:14px;
  }

}
.error-message
{
  zoom:.9;
  font-weight:bold;
}
.error-details
{
  zoom:.9;
  font-weight:normal;
}
</style>
